import angular from 'angular';

module.exports = angular.module('common.directives.empty-to-null', [])
.directive('emptyToNull', function emptyToNull() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ctrl) {
      ctrl.$parsers.push((viewValue) => {
        if (viewValue === '') {
          return null;
        }
        return viewValue;
      });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/empty-to-null.js
 **/